import WorkspaceConstants from './WorkspaceConstants';

export default function MessageActions (api, bus) {
    return {
        get: function (cb) {
            cb = cb || function () {};
            bus.emitAction({
                action: {
                    actionType: WorkspaceConstants.ASYNC_START,
                    data: null
                }
            });

            api.get(function (err, resp) {
                bus.emitAction({
                    action: {
                        actionType: WorkspaceConstants.ASYNC_END,
                        data: null
                    }
                });

                if (err) return cb(err);

                bus.emitAction({
                    action: {
                        actionType: WorkspaceConstants.MESSAGES_FETCHED,
                        data: resp
                    }
                });

                cb(null, resp);
            });
        },

        newMessage: function (data) {
            bus.emitAction({
                action: {
                    actionType: WorkspaceConstants.NEW_MESSAGE,
                    data: data
                }
            });
        },

        markMessageAsRead: function (type, id) {
            bus.emitAction({
                action: {
                    actionType: WorkspaceConstants.MESSAGES_MARK,
                    data: {
                        type: type,
                        id: id
                    }
                }
            });
        },

        haltApplication: function () {
            bus.emitAction({
                action: {
                    actionType: WorkspaceConstants.APPLICATION_HALT,
                    data: null
                }
            });
        },

        resumeApplication: function () {
            bus.emitAction({
                action: {
                    actionType: WorkspaceConstants.APPLICATION_RESUME,
                    data: null
                }
            });
        }
    };
};
